import React, { ReactChild } from "react"
import styled from "styled-components"

interface Props {
  type: "danger" | "waiting" | "success" | "info"
  children?: ReactChild | ReactChild[]
  size?: "sm" | "lg" | "fix" | "auto"
}

export const TypeColors = {
  danger: "#F02626",
  waiting: "#F08026",
  success: "#248B9E",
  info: "#076374",
  primary: "#6B6BF8",
  disabled: "#7B7C7E",
  itHeavy: "#60A7B4",
  draft: "#C93C6F",
}

export default function AcTag(props: Props) {
  const { children, type, size = "sm" } = props

  return (
    <>
      <Tag size={size} type={type}>
        {children}
      </Tag>
    </>
  )
}

const Tag = styled.span`
  color: #fff;
  font-weight: 600;
  border-radius: 20px;
  ${(props) => {
    if (props.size === "sm") {
      return "min-width: 64px; font-size: 13px;"
    } else if (props.size === "fix") {
      return "width: 105px; font-size: 13px;display: inline-block;"
    }
  }}
  ${(props) => props.size === "lg" && `width: 100px;`}
padding: 8px 16px;
  //display: flex;
  justify-content: center;
  background-color: ${(props) => TypeColors[props.type]};
  text-align: center;
`
